// extracted by mini-css-extract-plugin
export default {"tooltip":"infoTooltip_tooltip__8R9Xd"};